import { DoodApiError } from '@shared/interfaces/error.interface';
import { UpsellingData } from './upselling.model';

export interface UpsellingState {
  data: UpsellingData | null;
  isLoaded: boolean;
  isLoading: boolean;
  hasError: boolean;
  error: DoodApiError | null;
}

export const UPSELLING_STORE_KEY = 'Upselling';

export const UPSELLING_STORE_INITIAL_STATE: UpsellingState = {
  data: null,
  isLoaded: false,
  isLoading: false,
  hasError: false,
  error: null,
};
